"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Message_1 = require("./Message");
var Overlay_1 = require("../Overlay");
/**
 * @internal
 */
exports.Messages = function (_a) {
    var _b = _a.messages, messages = _b === void 0 ? [] : _b, _c = _a.onMessageClose, onMessageClose = _c === void 0 ? noop_1.default : _c;
    var _d = tslib_1.__read(react_1.useState(true), 2), shouldShowMore = _d[0], setShouldShowMore = _d[1];
    var handleMessageClose = react_1.useCallback(function (messageId) {
        setShouldShowMore(true);
        onMessageClose(messageId);
    }, []);
    var handleShowMore = react_1.useCallback(function (e) {
        e.preventDefault();
        setShouldShowMore(!shouldShowMore);
    }, [shouldShowMore]);
    var renderMessageWithShowMore = function (message) {
        var showMore = message.showMore, showLess = message.showLess, errorDetail = message.errorDetail, text = message.text, type = message.type;
        var contentClassNames = classnames_1.default("gd-message-text-content", "s-message-text-content", type, {
            off: shouldShowMore,
            on: !shouldShowMore,
        });
        var showMoreLinkClassNames = classnames_1.default("gd-message-text-showmorelink", "s-message-text-showmorelink", type);
        return (react_1.default.createElement("div", { className: "gd-message-text-showmore" },
            react_1.default.createElement("p", { className: "gd-message-text-header" },
                react_1.default.createElement("span", { className: "s-message-text-header-value", dangerouslySetInnerHTML: { __html: text } }),
                react_1.default.createElement("span", { className: showMoreLinkClassNames, onClick: handleShowMore }, shouldShowMore ? showMore : showLess)),
            react_1.default.createElement("div", { className: contentClassNames }, errorDetail)));
    };
    return (react_1.default.createElement(Overlay_1.Overlay, null,
        react_1.default.createElement("div", { className: "gd-messages" },
            react_1.default.createElement(react_transition_group_1.TransitionGroup, null,
                react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "gd-message", timeout: 220 },
                    react_1.default.createElement("div", null, messages.map(function (message) {
                        var id = message.id, component = message.component, showMore = message.showMore, text = message.text, type = message.type, contrast = message.contrast, intensive = message.intensive;
                        return (react_1.default.createElement("div", { key: id },
                            react_1.default.createElement(Message_1.Message, { className: "gd-message-overlay gd-message-overlay" + (showMore && "-custom"), type: type, onClose: function () {
                                    handleMessageClose(id);
                                }, contrast: contrast, intensive: intensive }, component ||
                                (showMore ? (renderMessageWithShowMore(message)) : (react_1.default.createElement("div", { className: "s-message-text-header-value", dangerouslySetInnerHTML: { __html: text } }))))));
                    })))))));
};
//# sourceMappingURL=Messages.js.map